import * as PropTypes from "prop-types";
import Bin from "./bin.svg";
import Icon from "./Icon";

export default function DeleteIcon({ className, style, onClick }) {
  const localStyle = {
    height: "1.5rem",
    width: "1.5rem",
    position: "relative",
    cursor: "pointer",
    ...style,
  };

  return (
    <Icon
      src={Bin}
      className={className}
      style={localStyle}
      onClick={onClick}
    />
  );
}

DeleteIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

DeleteIcon.defaultProps = {
  className: "",
  style: {},
};
